import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

/**
 * @group Icon Button
 * @component Icon Button
 * @description Icon Button
 */
@Component({
  selector: 'la-icon-button',
  template: `
    <div class="la-icon-button" (click)="onClick()" [ngClass]="{
        'la-icon-button--hover': isHover,
        'la-icon-button--active': isActive,
        'la-icon-button--disabled': isDisabled}"
         (mouseover)="isHover = true" (mouseout)="isHover = false">
      <ng-content></ng-content>
    </div>`,
  styles: [`
    .la-icon-button{border:none;margin:0;padding:0;cursor:pointer}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaIconButtonComponent {
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  private _isDisabled = false;

  // [isDisabled]
  get isDisabled(): boolean {
    return this._isDisabled;
  }

  /**
   * true - to make button disabled. false - by default
   */
  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  private _isHover = false;

  get isHover(): boolean {
    return this._isHover;
  }

  /**
   * To apply hovered style to a button. only used in style guide
   */
  @Input()
  set isHover(value: boolean) {
    this._isHover = value;
  }

  private _isActive = false;

  get isActive(): boolean {
    return this._isActive;
  }

  /**
   * To apply active style to a button. Used in sidebar or nav components to show active state
   */
  @Input()
  set isActive(value: boolean) {
    this._isActive = value;
  }

  onClick() {
    if (!this.isDisabled) {
      this.clicked.next();
    }
  }
}
